'use client';
import { useLocalStorage, useMediaQuery } from '@sbt-web/hooks';
import { TuttaItalia } from '@sbt-web/networking';
import React, { useCallback, useMemo } from 'react';
import { isHereAutocompleteOption } from './common/types.js';
import DesktopGeoSearch from './desktop/index.js';
import MobileGeoSearch from './mobile/index.js';
import useGeogos, { defaultLocation } from './useGeogos.js';
import useHere from './useHere.js';

const TuttaItaliaOption = {
    entry: { region: TuttaItalia },
    searchNearRegions: false,
    responseFrom: 'geogos',
};
function GeoSearch({ assetsBase, channel = 'web', debounceTimeout = 250, hadesBasePath, value = TuttaItaliaOption, labelId, name = '/geo', onDialogClose, onDialogOpen, onSelect, pulseInstance, resultsLimit = 10, hereApiKey, variant = 'base', updateResultsPreview, resultsPreview, }) {
    const [geogosItems, updateGeogosItems] = useGeogos(hadesBasePath, channel, debounceTimeout, resultsLimit);
    const [hereItems, updateHereItems] = useHere(hereApiKey, debounceTimeout);
    const [searches, setSearches] = useLocalStorage('recent_geo_searches_v2', []);
    const isMobile = useMediaQuery('(max-width: 767px)', false);
    const storeSelectedItem = useCallback((selectedItem) => {
        if (!selectedItem ||
            isHereAutocompleteOption(selectedItem) ||
            selectedItem.inputLabel === defaultLocation.inputLabel) {
            return;
        }
        selectedItem.isRecentSearch = true;
        if (!searches?.length) {
            setSearches([selectedItem]);
        }
        else {
            const searchesWithoutItem = searches.filter((s) => s.inputLabel !== selectedItem.inputLabel);
            // Put the search at the top as the most recent one and take 3 elements
            setSearches([selectedItem, ...searchesWithoutItem].slice(0, 3));
        }
    }, [searches, setSearches]);
    const options = useMemo(() => {
        if (hereItems.length > 0) {
            return {
                kind: 'map',
                items: hereItems,
            };
        }
        else if (geogosItems.length > 0) {
            return {
                kind: 'search',
                items: geogosItems,
            };
        }
        else if (searches && searches.length > 0) {
            return {
                kind: 'recent',
                items: [defaultLocation, ...searches],
            };
        }
        else {
            return { kind: 'new', items: [] };
        }
    }, [geogosItems, hereItems, searches]);
    const internalValue = useMemo(() => value, [value]);
    return isMobile ? (React.createElement(MobileGeoSearch, { hereApiKey: hereApiKey, assetsBase: assetsBase, value: internalValue, labelId: labelId, name: name, onDialogClose: onDialogClose, onDialogOpen: onDialogOpen, onSelect: onSelect, options: options, pulse: pulseInstance, storeRecentSearch: storeSelectedItem, updateItems: (from, query) => from === 'here' ? updateHereItems(query) : updateGeogosItems(query), variant: variant, updateResultsPreview: updateResultsPreview, resultsPreview: resultsPreview })) : (React.createElement(DesktopGeoSearch, { value: internalValue, labelId: labelId, name: name, onSelect: onSelect, options: options, pulse: pulseInstance, storeRecentSearch: storeSelectedItem, updateItems: (_, query) => updateGeogosItems(query), variant: variant, assetsBase: assetsBase }));
}

export { GeoSearch as default };
//# sourceMappingURL=GeoSearch.js.map
